import Vue from 'vue';
import VueResource from 'vue-resource';
import converterMoeda from '~js/converter-moeda';
import formatarData from '~js/formatar-data';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

async function normalizarParaSalvar(solicitacao) {
  delete solicitacao.projeto;
  delete solicitacao.protocolo;

  await Promise.all(solicitacao.despesas.map(async (despesa) => {
    despesa.data = await formatarData.paraNumero(despesa.data);

    return despesa;
  }));

  if (solicitacao.dataNascimento) {
    solicitacao.dataNascimento = await formatarData.paraNumero(solicitacao.dataNascimento);
  }
}

function normalizarParaVisualizar(solicitacao) {
  solicitacao.despesas.map(despesa => {
    despesa.data = formatarData.paraData(despesa.data);
    despesa.valor = converterMoeda.paraReal(despesa.valor);

    return despesa;
  });

  return solicitacao;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    const periodo = parametros.periodo;
    delete parametros.periodo;

    if (periodo) {
      parametros.dataInicio = moment(periodo[0], 'DD/MM/YYYY').format('MM/DD/YYYY');
      parametros.dataFim = moment(periodo[1], 'DD/MM/YYYY').format('MM/DD/YYYY');
    }

    return Vue.http.get('/api/solicitacaoreembolsoterceiro', { params: parametros });
  },
  adicionar: async (solicitacao, arquivos) => {
    await normalizarParaSalvar(solicitacao);
    solicitacao.arquivos = arquivos;

    solicitacao = await converterObjetoFormData(solicitacao);

    return Vue.http.post('/api/solicitacaoreembolsoterceiro', solicitacao).then(res => res.data.id);
  },
  alterar: async (solicitacao, arquivos, id) => {
    await normalizarParaSalvar(solicitacao);
    solicitacao.arquivos = arquivos;

    solicitacao = await converterObjetoFormData(solicitacao);

    return Vue.http.put(`/api/solicitacaoreembolsoterceiro/${id}`, solicitacao).then(res => res.data.id);
  },
  obterPorId: id => {
    return Vue.http.get(`/api/solicitacaoreembolsoterceiro/${id}`)
      .then(response => normalizarParaVisualizar(response.data));
  },
  liberar: id => {
    return Vue.http.post(`/api/solicitacaoreembolsoterceiro/${id}/liberar`)
      .then(response => response.data);
  },
  cancelar: id => {
    return Vue.http.post(`/api/solicitacaoreembolsoterceiro/${id}/cancelar`)
      .then(response => response.data);
  },
  reenviarEmail: id => {
    return Vue.http.get(`/api/solicitacaoreembolsoterceiro/${id}/reenviaremail`)
      .then(response => response.data);
  },
  arquivos: id => {
    return Vue.http.get(`/api/solicitacaoreembolsoterceiro/${id}/arquivos`)
      .then(response => response.data);
  },
  download: (id, arquivo) => {
    return Vue.http.get(`/api/solicitacaoreembolsoterceiro/${id}/downloadarquivo/${arquivo}`,
        {
          responseType: 'blob'
        })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-reembolso-terceiro/servico.js